import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="relative py-24 sm:py-32 border-t border-line">
      <div className="container-x">
        <div className="max-w-2xl mb-16">
          <span className="mono-label text-accent">[ Word on the street ]</span>
          <h2 className="font-head font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-4 text-balance">
            Local businesses love working with us.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="bg-surface border border-line p-8 flex flex-col accent-glow"
            >
              <Quote className="w-8 h-8 text-accent mb-6" />
              <blockquote className="text-white/90 leading-relaxed flex-1">"{t.quote}"</blockquote>
              <figcaption className="mt-8 pt-6 border-t border-line">
                <div className="font-head font-bold">{t.name}</div>
                <div className="mono-label text-text-2 mt-1">{t.role}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
